import { Drawer, useMediaQuery } from '@material-ui/core'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { mobileBreakpoint } from '../../lib/helper/viewportHelper'
import { setSearchQuery } from '../../redux/searchReducer'
import theme from '../../theme'
import Menu2 from './Menu2'

function Menu2Drawer({ toggleDrawer, ...otherProps }) {
    const dispatch = useDispatch()
    const [history, setHistory] = useState([])
    const isMobile = useMediaQuery(theme.breakpoints.down(mobileBreakpoint))

    const makeHistory = (list) => {
        if(!isMobile) return
        if(list === null ) {setHistory([]); return}
        setHistory(list)
    }

    const onItemClick = (id) => {
        dispatch(setSearchQuery({
            type: "menu2Drawer",
            value: { collections: [id] },
            clearFilter: true,
        }))
        toggleDrawer()
    }

    return (
        <Drawer
            {...otherProps}
        >
            <Menu2 toggleDrawer={toggleDrawer} onItemClick={onItemClick} history={history} makeHistory={makeHistory}/>
        </Drawer>
    )
}

export default Menu2Drawer